<template>
    <div>
        <div v-if="!fridgeId">
            Холодильник не выбран
        </div>
        <div v-if="fridgeId">
            <div>
                Антенны:
                <div class="antenna-buttons-block">
                    <button
                        class="btn antenna-btn"
                        :class="{'btn-warning': isAntennaChosen(antenna), 'btn-dark': !isAntennaChosen(antenna)}"
                        :style="{'width': `${antennaBtnWidthPercent}%`}"
                        v-for="antenna in antennas"
                        @click="toggleAntenna(antenna)"
                    >
                        {{antenna}}
                    </button>
                </div>
            </div>
            <div>
                <button class="btn btn-success antennas-all-btn" @click="selectAll()">
                    Вкл. все
                </button>
                <button class="btn btn-danger antennas-all-btn" @click="deselectAll()">
                    Откл. все
                </button>
            </div>

            <hr>

            <last-error-block></last-error-block>

            <div>
                <div v-if="isWaitingAnswer">
                    Ожидание первого ответа...
                </div>

                <div v-if="response && labels">
                    <div v-if="labels.length == 0">
                        (Нет меток)
                    </div>
                    <div v-if="labels.length > 0">
                        <div>
                            Найдено {{labels.length}} меток
                        </div>
                        <table class="table table-sm">
                            <tr>
                                <th>Метка</th>
                                <th>Антенна</th>
                                <th>Сигнал</th>
                            </tr>
                            <tr v-for="label in labels">
                                <td class="tag-label">{{label.tag}}</td>
                                <td>{{label.antenna}}</td>
                                <td>{{label.strength}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import fridgeRabbit from '../utils/rabbit/fridge_rabbit';
    import _ from 'lodash';
    import LastErrorBlock from "../components/LastErrorBlock";


    export default {
        name: "TestRfid",
        components: {LastErrorBlock},
        computed: {
            ...mapGetters('app', {
                fridgeId: 'fridgeId',
                antennas: 'antennas',
            }),
            antennaBtnWidthPercent() {
                return 100 / this.antennas.length;
            },
            isWaitingAnswer() {
                return this.response === null;
            },
            labels() {
                return this.response && this.response.labels ? this.response.labels : [];
            },
        },
        methods: {
            ...mapActions('app', {
                setLastError: 'setLastError',
                clearLastError: 'clearLastError',
            }),
            isAntennaChosen(antenna) {
                return this.selectedAntennas.indexOf(antenna) > -1;
            },
            toggleAntenna(antenna) {
                if(!this.isAntennaChosen(antenna)) {
                    this.selectedAntennas.push(antenna);
                } else {
                    let idx = this.selectedAntennas.indexOf(antenna);
                    if(idx < 0) {
                        return;
                    }
                    this.selectedAntennas.splice(idx, 1);
                }
                this.apply();
            },
            apply() {
                fridgeRabbit.send('test_rfid', {antennas: this.selectedAntennas});
                this.response = null;
            },
            onAnswer(data) {
                if(!data) {
                    return;
                }

                if(!data.success) {
                    this.setLastError(data.error);
                } else {
                    this.clearLastError();
                }

                this.response = data;
            },
            selectAll() {
                this.selectedAntennas = _.clone(this.antennas);
                this.apply();
            },
            deselectAll() {
                this.selectedAntennas = [];
                this.apply();
            },
        },
        data() {
            return {
                selectedAntennas: [],
                response: null,
            };
        },
        async mounted() {
            await fridgeRabbit.listen(this.onAnswer);
            this.selectAll();
        },
        destroyed() {
            fridgeRabbit.clear();
            this.clearLastError();
        },
    }
</script>

<style scoped>
    .tag-label {
        font-size: 0.8em;
    }
    .antennas-all-btn {
        width: 50%;
    }

    .antenna-buttons-block {
        margin: 10px 0;
        text-align: center;
    }
    .antenna-btn {
        height: 50px;
    }
    .antenna-selector input[type=checkbox] {
        transform: scale(2);
        margin: 0 5px;
    }
</style>
